var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more-reward-wrappper",on:{"click":function($event){$event.stopPropagation();return _vm.gotoMoreBuyMoreReward($event)}}},[_c('div',{staticClass:"banner-content"},[_c('img',{attrs:{"src":_vm.moreBuyBanner.image}})])])}
var staticRenderFns = []

export { render, staticRenderFns }